"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userAgent = exports.isAndroid = exports.fireFoxOnIOS = exports.chromeOnIOS = void 0;
var Bowser = _interopRequireWildcard(require("bowser"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var chromeOnIOS = function chromeOnIOS() {
  var userAgent = window.navigator.userAgent;
  var browser = Bowser.getParser(userAgent);
  return browser.satisfies({
    iOS: {
      chrome: '>=1'
    }
  });
};
exports.chromeOnIOS = chromeOnIOS;
var fireFoxOnIOS = function fireFoxOnIOS() {
  var userAgent = window.navigator.userAgent;
  var browser = Bowser.getParser(userAgent);
  return browser.satisfies({
    iOS: {
      firefox: '>=1'
    }
  });
};
exports.fireFoxOnIOS = fireFoxOnIOS;
var userAgent = function userAgent() {
  var _browser$getPlatform;
  var browser = Bowser.getParser(navigator.userAgent);
  return {
    name: browser.getBrowserName(),
    os: browser.getOSName(),
    plaform: (_browser$getPlatform = browser.getPlatform()) === null || _browser$getPlatform === void 0 ? void 0 : _browser$getPlatform.type
  };
};
exports.userAgent = userAgent;
var isAndroid = function isAndroid() {
  var osName = Bowser.getParser(navigator.userAgent).getOSName();
  return osName === 'Android';
};
exports.isAndroid = isAndroid;